var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBottomGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1375 9.69949L8.88749 16.6623C8.76861 16.7891 8.62843 16.8885 8.47499 16.9547C8.17066 17.094 7.82931 17.094 7.52499 16.9547C7.37155 16.8885 7.23137 16.7891 7.11249 16.6623L0.862486 9.69949C0.745896 9.56965 0.65352 9.41551 0.590428 9.24587C0.527337 9.07622 0.494934 8.8944 0.494934 8.71078C0.494934 8.33993 0.627138 7.98429 0.862486 7.72206C1.09784 7.45983 1.41705 7.3125 1.75 7.3125C2.08295 7.3125 2.40215 7.45983 2.63751 7.72206L6.74999 12.3175V1.74799C6.74999 1.37858 6.88168 1.02436 7.1161 0.76326C7.35052 0.502161 7.66847 0.355408 7.99999 0.355408C8.33151 0.355408 8.64945 0.502161 8.88387 0.76326C9.11829 1.02436 9.24999 1.37858 9.24999 1.74799V12.3175L13.3625 7.72206C13.4787 7.59149 13.6169 7.48789 13.7693 7.41716C13.9216 7.34644 14.085 7.31012 14.25 7.31012C14.415 7.31012 14.5784 7.34644 14.7307 7.41716C14.883 7.48789 15.0213 7.59149 15.1375 7.72206C15.2546 7.85151 15.3476 8.00553 15.4111 8.17523C15.4746 8.34492 15.5072 8.52694 15.5072 8.71078C15.5072 8.89461 15.4746 9.07663 15.4111 9.24632C15.3476 9.41602 15.2546 9.57004 15.1375 9.69949Z",
    fill: "#55B4BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBottomGreen);
export default __webpack_public_path__ + "static/media/icon-arrow-bottom-green.7ac7aaf84c29bcd7eacd2f9264cd8212.svg";
export { ForwardRef as ReactComponent };